<template>
  <div>
    <div :class="IS_IN_YTS_PUB?'readUs-in-yts':'readUs'" v-if="type === 0 || type === 3">
      <aside :style="getStyleTop">
        <!-- <el-checkbox v-if="type === 0" v-model="iscbFilter" :checked="iscbFilter" @change="handleFilter">催办排序</el-checkbox> -->
        <el-button size="small" :disabled="selectedDis" @click="readThose('')">{{ `选中置为已${type === 0 ? '办' : '读'}` }}</el-button>
        <el-button size="small" @click="readThose('-all-')">{{ `全部置为已${type === 0 ? '办' : '读'}` }}</el-button>
      </aside>
    </div>
    <el-table
      :header-cell-style="{'background':'#F5F5F5'}"
      :data="data"
      ref="tasksTable"
      :row-class-name="rowClass"
      :cell-class-name="cellClass"
      :header-cell-class-name="headerCellClass"
      @row-click="handleLink"
      @selection-change="handleSelectChange"
      @cell-dblclick="dbSelect"
      >

      <el-table-column :key="Math.random()" v-if="type === 0 || type === 3" type="selection" :selectable="selectAble" width="30" key="selection" ></el-table-column>

      <el-table-column :key="Math.random()" prop="title" :label="IS_IN_YTS_PUB?'主题':'审批名称'" show-overflow-tooltip key="info" class="ress">
        <template slot-scope="scope">
          <!-- <a class="hyperlink" :href="type === 2 ? (scope.row.pcTarget || null) : (scope.row.target || null)"> -->
          <div class="hyperlink" :class="{'h-35': !(type === 1 || type === 3 || (type === 2 && status === 1))}">
            <span class="cuiban ml" v-show="type === 0 && scope.row.isReminders === 1">【催办】</span>
            <span class="dohalf-title" :class="{'ml': scope.row.title&&scope.row.title.startsWith('【')}" v-html="highlight(scope.row.title)"></span>
            <div v-show="scope.row.pubTrueName || scope.row.pubUserAccount" v-if="type === 1 || type === 3 || (type === 2 && status === 1)">
              <span class="color93">发起人：</span>
              <span class="pubtruename" v-html="highlight(scope.row.pubTrueName ? scope.row.pubTrueName : scope.row.pubUserAccount)"></span>
              <span class="flow-name" v-show="scope.row.flowName">
                <span class="color93">审批类型：</span>
                <span class="pubtruename" v-html="highlight(scope.row.flowName)"></span>
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :key="Math.random()"
        v-if="type === 0 || (type === 2 && !(status == 1))"
        :label="IS_IN_YTS_PUB?'类型':'审批类型'"
        :width="isScreenSmall ? 140 : 160"
      >
        <template slot-scope="scope">
          <span v-html="highlight(scope.row.flowName)"></span>
        </template>
      </el-table-column>

      <!--我的待办 === 发起人 -->
      <el-table-column
        v-if="type === 0"
        label="发起人"
        :width="isScreenSmall ? 80 : 110"
        :key="Math.random()"
      >
        <template slot-scope="scope">
          <span>{{scope.row.pubTrueName ? scope.row.pubTrueName : scope.row.pubUserAccount}}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="type === 0 || type === 3"
        prop="receiveTime"
        label="到达时间"
        width="110"
        :formatter="formatDate"
        key="receiveTime"
        class="time"
      >
      </el-table-column>

      <!--我的待办 === 停留时长 -->
      <el-table-column
        v-if="type === 0"
        label="停留时长"
        :width="isScreenSmall ? 100 : 160"
        key="keepTime0"
        :render-header="renderHeader"
      >
      <template slot-scope="scope">
       <div >
        <div >
          <span class="fw">{{scope.row.stayTime }}</span>
          <span >{{scope.row.stayTimeUnit }}</span>
        </div>
       </div>
      </template>
      </el-table-column>

      <el-table-column
        v-if="type === 1"
        prop="updateTime"
        label="处理时间"
        width="110"
        class="time"
        :formatter="formatDate"
        key="updateTime"
      >
      </el-table-column>

      <el-table-column
        v-if="type === 2"
        prop="createTime"
        label="发起时间"
        class="time"
        width="130"
        :formatter="formatDate"
        key="createTime"
      >
      </el-table-column>

      <el-table-column width="70" v-if="type === 0">
        <template slot-scope="scope">
          <div class="clearFlex">
              <i
              v-if="hasDelBtn(scope.row)"
              class="el-icon-delete delete-btn"
              @click.stop="handleDelete(scope.row)"
            ></i>
            <span class="ml6"  v-if="hasDelBtn(scope.row)"
              @click.stop="handleDelete(scope.row)">清除</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-if="type === 2 && !(status == 1)"
        show-overflow-tooltip
        :label="IS_IN_YTS_PUB?'当前负责人':'当前审批人'"
        width="200"
        key="appvUser"
      >
        <template slot-scope="scope">
          <div class="session" v-if="(scope.row.appvUser&&scope.row.appvUser.length==1 && scope.row.appvUser[0].lxFlag != 2)&&scope.row.appvUser.every(item=>{return item.appvUserName!='Administrator'})">
            <img src="@/assets/images/session.svg" alt class="w-24" @click.stop="toDailogLongXin(scope.row.appvUser[0].appvUserName, scope.row.appvUser[0].appvUserAccount, scope.row)" v-if="(scope.row.pubTrueName != scope.row.appvUser[0].appvUserName || scope.row.pubUserAccount != scope.row.appvUser[0].appvUserAccount) && scope.row.appvUser[0].lxFlag == 1" />
            <span class="ml-3">
              <span class="c-primary c-pointer">{{scope.row.appvUser[0].appvUserName}}</span>
            </span>
          </div>
          <div class="session c-primary" v-if="((scope.row.appvUser&&scope.row.appvUser.length==1 && scope.row.appvUser[0].lxFlag == 2)||(scope.row.appvUser && scope.row.appvUser.some(item=>{return item.appvUserName=='Administrator'})))">
            {{scope.row.appvUser[0].appvUserName}}
          </div>
           <!-- 交单/财务共享平台处理中 -->
          <div class="session-more c-primary" @click.stop="toSetDialog(scope.row)" v-if="scope.row.appvUser&&scope.row.appvUser.length && scope.row.appvUser.length > 1&&scope.row.appvUser.every(item=>{return item.appvUserName!='Administrator'})">
            <img src="@/assets/images/session-more.png" alt class="w-24" />
            <div class="ml-3 c-pointer session-more-box">
              <span
                  v-for="(item, index) in scope.row.appvUser"
                  :key="index"
                >{{item.appvUserName}}<span v-if="index < (scope.row.appvUser&&scope.row.appvUser.length-1)">、</span>
                </span>
            </div>等{{scope.row.appvUser&&scope.row.appvUser.length}}人
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-if="type === 2 && !(status == 1)"
        label="停留时长"
        width="190"
        key="keepTime2"
      >
      <!-- 费控time -->
      <template slot-scope="scope" >
        <div>
            <span class="fw">{{scope.row.stayTime }}</span>
          <span >{{scope.row.stayTimeUnit }}</span>
        </div>
      </template>
      </el-table-column>
    </el-table>
    <SessionDialog :sessionDialogVisible.sync="sessionDialogVisible" :sessionItem="sessionItem"/>
  </div>
</template>

<script>
import SessionDialog from './SessionDialog'
import { markRead, markDone, cencus, whatFilter, getTodoList } from '@/api/index'
import { debounce } from '../utils/index'
import { sendRocketChatMessage } from '@/utils/rocketChat'

export default {
  name: 'VTaskList',
  components: { SessionDialog },
  props: {
    status: Number, // -1 全部 0 未完成 1 已完成
    data: Array,
    height: Number,
    type: Number,
    keyword: String,
    markedIds: Array,
    markedSystemNo: Array,
    markedBusinessType: Array
  },
  data () {
    return {
      selectedDis: true,
      markedItem: [],
      iscbFilter: false,
      currUser: '', // /todo/cuiban/order/get 返回的当前登录账号，供 Rocket.Chat 等使用

      sessionDialogVisible: false,
      sessionItem: {},
      username: '', // 目标人
      flowId: '', // 实例Id
      isScreenSmall: false, // 是否是小屏，暂定宽度小于1280
      IS_IN_YTS_PUB:false//是否在云图梭中
    }
  },
  watch: {
    markedIds(ids) {
      if (ids && ids.length > 0) {
        this.markedItem = this.data.filter(task => ids.indexOf(task.todoId) > -1)
      }
    }
  },
  computed: {
    getStyleTop: function() {
      let style = ''
      if (this.type === 0) {
        style = 'top: -100px;'
      } else if (this.type === 3) {
        style = 'top: -70px;'
      } else {
        style = 'top: -70px;'
      }
      return style
    }
  },
  methods: {
    // 催办排序
    handleFilter(value) {
      if (value) {
        this.$emit('cuibanFilter')
      } else {
        this.$emit('defaultFilter')
      }
      this.$emit('orderTimeFilter')
    },
    cellClass({ row, column, rowIndex, columnIndex }) {
      if (this.type === 0 || this.type === 2) {
        if (columnIndex == 0) {
          if (column.label == '当前节点停留时长' || column.label == '停留时长') {
          // return ['pl-40']
            return ['bold', 'firstCell']
          } else {
            return 'firstCell'
          }
        }
      }

      if (column.label == '当前节点停留时长' || column.label == '停留时长') {
        // return ['pl-40']
        return ['bold']
      }
    },
    headerCellClass({ row, column, rowIndex, columnIndex }) {
      if (column.label == '停留时长') {
        // return ['pl-40']
      }
    },
    rowClass({ row, i }) {
      let res = []
      // 我代办的, 已读; 我发起的, 已完成 置灰
      const flag2 = this.type === 2 && row.flowStatus === 1
      const flag3 = this.type === 3 && row.isRead === 1
      // (flag2 || flag3) && res.push('isGray')
      if (this.type == 0) {
        if ((((new Date().getTime() - row.receiveTime - row.consultTime) / 1000 / 60 / 60) / 24).toFloor(0) == 1) {
          if (flag2 || flag3) {
            return 'isGray borderBlue'
          } else {
            return 'borderBlue'
          }
        }
        if ((((new Date().getTime() - row.receiveTime - row.consultTime) / 1000 / 60 / 60) / 24).toFloor(0) == 2) {
          if (flag2 || flag3) {
            return 'isGray borderYellow'
          } else {
            return 'borderYellow'
          }
        }
        if ((((new Date().getTime() - row.receiveTime - row.consultTime) / 1000 / 60 / 60) / 24).toFloor(0) >= 3) {
          if (flag2 || flag3) {
            return 'isGray borderRed'
          } else {
            return 'borderRed'
          }
        }
      }
      if (this.type == 2) {
        if ((row.keepTime / 24).toFloor(0) >= 3 && (row.keepTime / 24).toFloor(0) < 5) {
          if (flag2 || flag3) {
            return 'isGray borderBlue'
          } else {
            return 'borderBlue'
          }
        }
        if ((row.keepTime / 24).toFloor(0) >= 5 && (row.keepTime / 24).toFloor(0) < 7) {
          if (flag2 || flag3) {
            return 'isGray borderYellow'
          } else {
            return 'borderYellow'
          }
        }
        if ((row.keepTime / 24).toFloor(0) >= 7) {
          if (flag2 || flag3) {
            return 'isGray borderRed'
          } else {
            return 'borderRed'
          }
        }
      }
      if (this.type === 0) {
        if (flag2 || flag3) {
          return 'isGray borderNone'
        } else {
          return 'borderNone'
        }
      } else {
        if (flag2 || flag3) {
          return 'isGray'
        }
      }
    },
    // 待办/通知 点击标记已读。待办不可查看提示
    handleLink(row, column, event) {
      let href = this.type === 2 ? row.pcTarget : row.target
      // 点击待办的统计
      if (href && this.type === 0) {
        cencus(row.todoId).then(res => {
        })
      }

      if (row.isRead !== 1) {
        if (this.type === 0 || this.type === 3) {
          let todoType = this.type === 0 ? 0 : 1
          markRead(row.todoId, todoType).then(res => {
            if (this.type === 3 && !row.spare && !row.target) {
              return false
            }
            if (!href) {
              return false
            }
            if (res.code === 0) {
              row.isRead = 1
              this.type === 3 && this.$emit('reload')
            }
          })
        }
      }
      if (this.type === 3 && !row.spare && !row.target) {
        this.$message.warning('该通知我已知悉')
        return false
      }
      if (!href) {
        this.$message.warning('请到移动端查看该待办')
        return false
      }
      if (href) {
        // 在云图梭中
        const IS_IN_YTS = window.jsBridge && window.jsBridge.runEnvyts
        let title = row.title ? row.title : '待办'
        title = title.length > 15 ? title.substring(0, 15) + '...' : title
        console.log('is in YTS?' + IS_IN_YTS)
        console.log('url:' + href)
        if (IS_IN_YTS) {
          window.jsBridge.handleLocalDialog(true, 'appCenter', href, title)
        } else {
          window.open(href)
        }
      }
      window.zhuge.track('点击待办跳转', {
        tab: this.type,
        systemNo: row.systemNo,
        businessType: row.businessType,
        todoId: row.todoId
      })
    },
    renderHeader() {
      if (this.type === 0) {
        return (
          <span class='pd3'>
            <span class='line30'>停留时长</span>
            <span class='little'>
              <i class='ma-r-info' title='使用BPM3引擎的流程已剔除协商时长，部分自带引擎的系统未剔除协商时长'></i>
            </span>
          </span>
        )
      }
    },
    // 发起时间特殊处理
    formatDate(row, column, cellValue, index) {
    // formatDate(cellValue) {
      let zero = function (value) {
        if (value < 10) {
          return '0' + value
        }
        return value
      }
      // 判断是否是昨天
      function isYesterday(time) {
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        const today = `${year}/${month}/${day}`
        const todayTime = new Date(today).getTime() // 当天凌晨的时间
        const yesterdayTime = new Date(todayTime - 24 * 60 * 60 * 1000).getTime() // 昨天凌晨的时间
        return time < todayTime && yesterdayTime <= time
      }
      // 判断是否是前天
      function isLastYesterday(time) {
        const twentyFourHours = 24 * 60 * 60 * 1000
        const fortyEightHours = 24 * 60 * 60 * 1000 * 2
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        const today = `${year}/${month}/${day}`
        const todayTime = new Date(today).getTime() // 当天凌晨的时间
        const yesterdayTime = new Date(todayTime - twentyFourHours).getTime() // 昨天凌晨的时间
        const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime() // 昨天凌晨的时间
        return time < yesterdayTime && lastYesterdayTime <= time
      }
      // 判断是否是今天
      function isToday(time) {
        let createTime = new Date(time)
        let nowTime = new Date()
        return createTime.toDateString() === nowTime.toDateString()
      }

      function getTime() {
        var date = new Date(cellValue)
        return zero(date.getHours()) + ':' + zero(date.getMinutes())
      }
      if (isYesterday(cellValue)) {
        return '昨天' + getTime()
      } else if (isLastYesterday(cellValue)) {
        return '前天' + getTime()
      } else if (isToday(cellValue)) {
        return getTime()
      } else {
        return (function () {
          var date = new Date(cellValue)
          return date.getFullYear() + '/' + zero(date.getMonth() + 1) + '/' + zero(date.getDate())
        })()
      }
    },
    // 是否可删除
    hasDelBtn(row) {
      // 如果是禁用的则不显示删除按钮
      if(/(BPM3|NMVIP|MVIP)/.test(row.flowEngine)){
        //return false;
      }
      // 超过七天的才可以显示删除按钮
      const nowTime = new Date().getTime()
      const days = Math.floor((nowTime - row.createTime) / 1000 / 60 / 60 / 24)
      return days >= 7
    },
    // 点击删除
    handleDelete(row) {
      this.$emit('delData', row)
    },
    // 勾选事件变化后事件处理
    handleSelectChange (row) {
      this.selectedDis = row && row.length === 0
      this.$emit('markIds', JSON.stringify(row.map(x => x.todoId)))
      this.$emit('zhugeParmas', row)
    },
    //  勾选操作事件处理
    dbSelect(row, column, cell, event){
      if(this.type===0 && /(BPM3|NMVIP|MVIP)/.test(row.flowEngine) && column.type=="selection"){
        this.$message({
          showClose: true,
          message: '审批类待办不支持选中置为已办功能',
          type: 'warning',
          duration:2000
        });
      }
    },
    // 选中/全部标为已读
    readThose(option) {
      let todoId = `${option || this.markedIds.toString()}`
      let todoType = 1
      if (this.type === 0) {
        if (option === '-all-') {
          this.$confirm('此操作将全部置为已办, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              markDone(todoId, todoType).then(res => {
                if (res.code === 0) {
                  this.$emit('reload', true)
                }
              })
              let todoCount = localStorage.getItem('todoCount') === '0' ? '10' : localStorage.getItem('todoCount')
              let params = {
                isPc: 1,
                keyword: '',
                tag: '',
                pageNo: 1,
                pageSize: todoCount,
                todoType: 0,
                todoStatus: 0,
                isRead: -1,
                startDate: '',
                endDate: ''
              }
              getTodoList(params).then(res => {
                if (res.code === 0) {
                  let data = res.data && res.data.list
                  data && data.forEach(item => {
                    window.zhuge.track('全部置为已办', {
                      systemNo: item.systemNo,
                      businessType: item.businessType,
                      todoId: item.todoId
                    })
                  })
                }
              })
            })
            .catch(() => {})
        } else {
          window.zhuge.track('选中置为已办', {
            systemNo: this.markedSystemNo,
            businessType: this.markedBusinessType,
            todoId: todoId
          })
          markDone(todoId, todoType).then(res => {
            if (res.code === 0) {
              this.$emit('reload', true)
            }
          })
        }
      } else {
        if (option === '-all-') {
          this.$confirm('此操作将全部置为已读, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              markRead(todoId, todoType).then(res => {
                if (res.code === 0) {
                  this.$emit('reload')
                }
              })
              let noticeCount = localStorage.getItem('noticeCount') === '0' ? '10' : localStorage.getItem('noticeCount')
              let params = {
                isPc: 1,
                keyword: '',
                tag: '',
                pageNo: 1,
                pageSize: noticeCount,
                systemNo: '',
                todoType: 1,
                todoStatus: 0,
                isRead: -1,
                startDate: '',
                endDate: ''
              }
              getTodoList(params).then(res => {
                if (res.code === 0) {
                  let data = res.data && res.data.list
                  data && data.forEach(item => {
                    window.zhuge.track('全部置为已读', {
                      systemNo: item.systemNo,
                      businessType: item.businessType,
                      todoId: item.todoId
                    })
                  })
                }
              })
            })
        } else {
          window.zhuge.track('选中置为已读', {
            systemNo: this.markedSystemNo,
            businessType: this.markedBusinessType,
            todoId: todoId
          })
          markRead(todoId, todoType).then(res => {
            if (res.code === 0) {
              this.$emit('reload')
            }
          })
        }
      }
      // 操作完清除存储数据
      localStorage.setItem('markedIds', [])
    },
    // 高亮搜索匹配文案
    highlight(html) {
      if (!html) return
      let highHtml = html.replace(this.keyword, `<span style="color: #409EFF">${this.keyword}</span>`)
      return highHtml
    },
    // 会话弹框
    toSetDialog(val) {
      this.sessionDialogVisible = true
      this.sessionItem = val
      console.log(this.sessionItem)
    },
    toDailogLongXin(realName, username, item) {
      if (item.pubUserAccount == username) {
        return
      }
      window.zhuge.track('点击Pc梧桐洲会话', {
        flowId: item.flowId,
        aprovalAccounts: [username]
      })
      this.username = username
      this.flowId = item.flowId
      this.$confirm(`是否与${realName}（${username}）发起梧桐洲会话？（含审批详情信息）`, '提示', {
        customClass: 'el-message-box-new'
      }).then((action) => {
        this.toSubmit(item)
      })
    },
    async toSubmit(item) {
      const suser = this.currUser || localStorage.getItem('account')
      if (!suser) {
        this.$message.error('未获取到当前登录账号，请重新登录')
        return
      }
      const postData = {
        objectName: 'RC:ImgTextMsg',
        suser,
        rusers: [this.username]
      }
      const url = this.flowId
      const pub = item.pubTrueName || item.pubUserAccount || ''
      const title = item.title || item.flowName || '审批'
      const content = `${pub}提交的【${title}】,请您处理。`
      const res = await sendRocketChatMessage({
        url,
        content,
        postData,
        vm: this
      })
      if (res && res.status === 200) {
        window.zhuge.track('点击Pc梧桐洲会话二次确认按钮', {
          flowId: this.flowId,
          aprovalAccounts: [this.username],
          systemNo: item.systemNo
        })
        this.$message.info('消息已提交')
      }
    },
    // 判断窗口尺寸，适配在云图梭中的样式
    getIsSmallScreen() {
      let screenWidth = 0
      if (window.innerWidth) {
        screenWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        screenWidth = document.body.clientWidth
      }
      this.isScreenSmall = screenWidth < 1080
      console.log('窗口宽度：' + screenWidth, '是否小屏：' + this.isScreenSmall)
    },
    // 复选框是否可选
    selectAble(row,index){
        // 在我的待办中匹配以下字段的默认置灰
        if(this.type===0 && /(BPM3|NMVIP|MVIP)/.test(row.flowEngine)){
           return false
        }
        return true;
    }
  },
  created() {
    // 去尾法
    Number.prototype.toFloor = function (num) {
      return Math.floor(this * Math.pow(10, num)) / Math.pow(10, num)
    }
    whatFilter().then(res => {
      if (res.code === 0 && res.data) {
        this.iscbFilter = res.data.isAtTop === 1
        if (res.data.account != null && res.data.account !== '') {
          this.currUser = res.data.account
        }
      }
    })
  },
  mounted() {
    const _self = this
    this.getIsSmallScreen()
    window.addEventListener('resize', debounce(_self.getIsSmallScreen, 300))
    // 在云图梭中
    this.IS_IN_YTS_PUB = window.jsBridge && window.jsBridge.runEnvyts
  }
}
</script>

<style>

/* .el-table .cell {
  word-break: keep-all !important;
} */
/* 已读, 已完成 */
tr.isGray,
tr.isGray .hyperlink {
  color: #909399;
}
.cell {
  display: flex;
  align-items: flex-start;
}
/* 超链接 */
.hyperlink {
  cursor: pointer;
  display: inline-block;
  width: calc(100% - 10px);
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.hyperlink1 {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
tbody tr:hover, tbody tr:hover .dohalf-title{
  color: #92b5ff !important;
  background:  #EEF3FD !important;
}
tbody tr:hover, tbody tr:hover .pubtruename{
  color: #92b5ff !important;
  background:  #EEF3FD !important;
}
tbody tr:hover, tbody tr:hover .color93 {
  /* color: #32a0f0 !important;
  background: #ecf5ff !important; */
  color: #92b5ff !important;
  background:  #EEF3FD !important;
}
.color93 {
  color: #939393;
}
.delete-btn {
  color: #333333;
}
/* 催办 */
.cuiban {
  display: inline-block;
  height: 18px;
  color: #ff0000;
  text-align: center;
  line-height: 18px;
  /* margin-right: -5px; */
  font-size: 16px;
}
.ml {
  /* margin-left: -8px; */
  margin-left: -0.5em;
}
/* .isReminder::before {
  content: '催办';
  display: inline-block;
  width: 39px;
  height: 20px;
  margin-right: 8px;
  border: 1px solid #ff0000;
  border-radius: 4px;
  color: #ff0000;
  text-align: center;
  font-size: 12px;
} */
.flow-name {
  margin-left: 20px;
}
/* 删除 */
.delete-btn {
  cursor: pointer;
}
.delete-btn:hover {
  color: #ff0000;
}
.readUs {
  position: relative;
  width: 100%;
  height: 1px;
  text-align: right;
}
.readUs aside {
  position: absolute;
  right: 20px;
  top: -100px;
}
.readUs-in-yts {
  position: relative;
  width: 100%;
  text-align: right;
  padding-top: 10px;
  padding-bottom: 10px;
}
.readUs-in-yts aside {
  display: flex;
  justify-content: flex-start;
}
.dohalf-title {
  font-size: 16px;
}
.w-24 {
  width: 24px;
}
.ml-3 {
  margin-left: 3px;
}
.c-pointer {
  cursor: pointer;
}
.c-primary {
  color: #5587F0;
}
.has-gutter .el-table-column--selection::before{
    content: ' ';
    border-left: 5px solid #f5f7fa00;
    display: inline-block;
    height: 32px;
    position: relative;
    left: 0px;
    top: 13px;
    margin-top: -26px;
    border-radius: 0px 2px 2px 0px;
}
.el-table{
  color: #323232 !important;
}
 .el-table th{
  overflow: visible !important;
}

.firstCell .el-tooltip{
   border-left: 6px solid #EAEAEA;
   border-radius: 0px 2px 2px 0px;
}
.borderRed .firstCell .el-tooltip{
   border-left: 6px solid #FF3B30;
   border-radius: 0px 2px 2px 0px;
}
.borderYellow .firstCell .el-tooltip{
   border-left: 6px solid #FF962F;;
}
.borderBlue .firstCell .el-tooltip{
   border-left: 6px solid #F0DC5A;
}
</style>
<style scoped>
.session {
  display: flex;
  align-items: center;
  /* width: calc(100% - 40px); */
}
.session-more {
  display: flex;
  align-items: center;
  /* width: calc(100% - 40px); */
}
.session-more-box {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 120px;
}
.session img {
  vertical-align: middle;
}
.readUs .el-checkbox {
  margin-right: 36px;
}
>>>.pl-40 {
  padding-left: 40px;
}
>>>.bold {
  color: #323232;
}
.fw{
  font-weight:800;
}
>>>tr.isBlue {
  background: #EEF3FD !important;
}
>>>tr.isRed {
  background: #FEEFF3 !important;
}
>>>tr.isOrange {
  background: #FFF8EE !important;
}
.h-35 {
  height: 35px;
  line-height: 35px;
}

 >>>.borderRed .cell .el-checkbox::before{
    content: ' ';
    border-left: 6px solid #FF3B30;
    display: inline-block;
    height: 36px;
    position: relative;
    left: -13px;
    top: 12px;
    margin-top: -24px;
    border-radius: 0px 2px 2px 0px;
}
 >>>.borderRed .cell{
  overflow: inherit;
}
 >>>.borderYellow .cell .el-checkbox::before{
    content: ' ';
    border-left: 6px solid #FF962F;
    display: inline-block;
    height: 36px;
    position: relative;
    left: -13px;
    top: 12px;
    margin-top: -24px;
    /* border-radius: 0px 2px 2px 0px; */
}
 >>>.borderYellow .cell{
  overflow: inherit;
}
 >>>.borderBlue .cell .el-checkbox::before{
    content: ' ';
    border-left: 6px solid #F0DC5A;
    display: inline-block;
    height: 36px;
    position: relative;
    left: -13px;
    top: 12px;
    margin-top: -24px;
    /* border-radius: 0px 2px 2px 0px; */
}
 >>>.borderBlue .cell{
  overflow: inherit;
}
 >>>.borderNone .cell .el-checkbox::before{
    content: ' ';
    border-left: 6px solid #EAEAEA;
    display: inline-block;
    height: 36px;
    position: relative;
    left: -14px;
    top: 14px;
    margin-top: -24px;
    /* border-radius: 0px 2px 2px 0px; */
}
 >>>.borderNone .cell{
  overflow: inherit;
}
.clearFlex{
  display: flex;
  align-items: center;
}
.ml6{
  margin-left: 6px;
}

.pd3{
  /* padding-top: 3px; */
  display: inline-block;
  position: relative;
}
.line30{
  line-height: 13px !important;
}
.little{
  font-size: 10px;
  line-height: 13px !important;
  width: 20px;
  height: 15px;
  display: block;
  position: absolute;
  right: -20px;
  top: 50%;
  margin-top: -8px;
}
.ma-r-info{
  font-size: 16px;
  color: #5587f0;
  width: 20px;
  height: 15px;
}

</style>
